// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2cDBJ","title":"Images45_title__CwCIT","images":"Images45_images__1BkH8"};